<template>
  <div class="main">
    <div class="main_list">
      <boxStyle title="数据总览" :show-bg="false">
        <div class="data_screening">
          <screeningItem
            v-for="item in dataScreeningData"
            :key="item.title"
            v-bind="item"
          ></screeningItem>
        </div>
      </boxStyle>
      <!-- 地市年度资金 -->
      <boxStyle title="地方成果汇总"
        ><div style="flex: 1" ref="yera"></div
      ></boxStyle>
       <!-- title="地市资金分布" -->
      <boxStyle title="地市学校分布">
        <div
          style="
            display: flex;
            flex: 1;
            overflow: hidden;
            flex-direction: column;
          "
        >
          <table class="tables">
            <colgroup>
              <col width="20%" />
              <col width="40%" />
              <!-- <col width="15%" />
              <col /> -->
              <col width="20%" />
              <col width="20%" />
            </colgroup>
            <thead>
              <tr>
                <th>地市排名</th>
                <th>地市</th>
                <!-- <th>资金总额</th> -->
                <th>学校数量</th>
                <th>占比</th>
              </tr>
            </thead>
          </table>
          <div style="flex: 1; overflow: auto">
            <table class="tables" style="flex: 1; overflow: auto">
              <colgroup>
                <col width="20%" />
                <col width="40%" />
                <!-- <col /> -->
                <col width="20%" />
                <col width="20%" />
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <img
                      style="width: 40px; height: 100%"
                      src="@/assets/images/bigData/one.png"
                      alt=""
                      srcset=""
                    />
                  </td>
                  <td>太原</td>
                  <!-- <td>5200万元</td> -->
                  <td>64</td>
                  <td>10.92%</td>
                </tr>
                <tr>
                  <td>
                    <img
                      style="width: 40px; height: 100%"
                      src="@/assets/images/bigData/two.png"
                      alt=""
                      srcset=""
                    />
                  </td>

                  <td>吕梁</td>
                  <!-- <td>4600万元</td> -->
                  <td>12</td>
                  <td>9.66%</td>
                </tr>
                <tr>
                  <td>
                    <img
                      style="width: 40px; height: 100%"
                      src="@/assets/images/bigData/three.png"
                      alt=""
                      srcset=""
                    />
                  </td>
                  <td>长治</td>
                  <!-- <td>4500万元</td> -->
                  <td>27</td>
                  <td>9.45%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      4
                    </div>
                  </td>
                  <td>忻州</td>
                  <!-- <td>4400万元</td> -->
                  <td>23</td>
                  <td>9.24%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      5
                    </div>
                  </td>
                  <td>晋中</td>
                  <!-- <td>4300万元</td> -->
                  <td>34</td>
                  <td>9.03%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      6
                    </div>
                  </td>
                  <td>朔州</td>
                  <!-- <td>4300万元</td> -->
                  <td>14</td>
                  <td>9.03%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      7
                    </div>
                  </td>
                  <td>晋中</td>
                  <!-- <td>4300万元</td> -->
                  <td>14</td>
                  <td>9.03%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      8
                    </div>
                  </td>
                  <td>大同</td>
                  <!-- <td>4200万元</td> -->
                  <td>12</td>
                  <td>8.03%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      9
                    </div>
                  </td>
                  <td>晋城</td>
                  <!-- <td>4200万元</td> -->
                  <td>10</td>
                  <td>8.03%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      10
                    </div>
                  </td>
                  <td>阳泉</td>
                  <!-- <td>4000万元</td> -->
                  <td>10</td>
                  <td>7.63%</td>
                </tr>
                <tr>
                  <td>
                    <div
                      style="
                        margin: auto;
                        border-radius: 45px;
                        width: 25px;
                        height: 25px;
                        background: #375379;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      11
                    </div>
                  </td>
                  <td>临汾</td>
                  <!-- <td>3800万元</td> -->
                  <td>5</td>
                  <td>5.92%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </boxStyle>
    </div>
    <div ref="map" id="map">
      <div class="main_map_select_box" v-if="CityList.length" ref="select">
        <div
          v-for="item in CityList"
          :style="
            selectCity
              ? selectCity.adcode == item.adcode
                ? 'background:url(' +
                  require('@/assets/images/bigData/border_3.png') +
                  ') no-repeat;background-size:100% 100%;'
                : ''
              : ''
          "
          :key="item.adcode"
          @click="clickCity(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="main_list">
      <boxStyle title="思政工作室建设情况" ref="studio"
        ><div style="flex: 1" id="studio"></div
      ></boxStyle>
      <boxStyle title="特色文化育人品牌建设情况"
        ><div style="flex: 1" ref="brand" id="brand"></div
      ></boxStyle>
      <boxStyle title="思政微课建设情况"
        ><div id="course" style="flex: 1" ref="course"></div
      ></boxStyle>
    </div>
    <svg
      width="100%"
      ref="line"
      height="100%"
      style="
        position: absolute;
        z-index: 9;
        pointer-events: none;
        overflow: hidden;
      "
      v-html="svgDom"
    ></svg>
    <div class="alert_box" ref="alert" v-if="selectCity">
      <a-icon
        type="close"
        style="position: absolute; top: 10px; right: 10px; cursor: pointer"
        @click="selectClear"
      />
      <div class="alert_box_title" @click="$router.push({path:'/home/cityTotal',query:{name:selectCity.name}})">
        {{ selectCity.name }}
      </div>
      <div class="alert_box_content">
        <div v-for="item in table" :key="item.title">
          <div>{{ item.title }}</div>
          <div>
            {{ item.value
            }}<span style="color: #fff; font-size: 14px">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="alertMapData"
      class="alert_map"
      ref="alertModel"
      @click="alertMapData = null"
    >
      <div ref="alertMapBox" @click.stop="">
        <div class="alert_map_title">
          {{ alertMapData?alertMapData.name:''}}基地汇总<a-icon
            type="close"
            style="position: absolute; top: 20px; right: 25px; cursor: pointer"
            @click="alertMapData = null"
          />
        </div>
        <div class="alert_map_box"></div>
        <div
          class="alert_map_point"
          v-for="(i, index) in alertPointDomData"
          :key="index"
          :id="i.adcode"
        >
          <div class="alert_map_point_content">
            <div class="alert_map_point_content_icon"></div>
            <span class="alert_map_point_content_text"
              >基地 {{ index + 1 }}个</span
            >
          </div>
          <img src="@/assets/images/bigData/alert_point.png" alt="" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "ol-ext/dist/ol-ext.css";
import "ol/ol.css";
import Highcharts from "highcharts";
import { getVectorContext } from "ol/render";
import { Style, Fill, Text, Stroke, Circle, Icon } from "ol/style";
import { asArray } from "ol/color";
import { Vector as layerVector, Image } from "ol/layer";
import { Vector as sourceVector, ImageStatic } from "ol/source";
import { Feature, View, Map, Overlay } from "ol";
import Render3D from "ol-ext/layer/Render3D";
import Perspective from "ol-ext/map/PerspectiveMap";
import { MouseWheelZoom, DragPan } from "ol/interaction";
import { Point } from "ol/geom";
import { GeoJSON } from "ol/format";
import { fromLonLat } from "ol/proj";
import { defaults as defaultInteractions } from "ol/interaction";
import boxStyle from "@/components/bigData/boxStyle";
import screeningItem from "@/components/bigData/screeningItem";
// 动画播放总控制器
class animationSupper {
  funList = {}; //所有的动画
  //修改动画
  setAnimationAct(animationAct) {
    this.funList.map((item) => item.animationAct());
    this.setAnimationAct = animationAct;
    return this;
  }

  //动画播放方法
  animationFun() {
    if (!Object.keys(this.funList).length) return;
    Object.values(this.funList).map((item, key) => {
      item();
    });
    requestAnimationFrame(() => this.animationFun());
  }

  // 修改动画
  setFun(keyValue, fun) {
    let key = keyValue ? keyValue : Math.random();
    this.funList[key] = fun;
    this.animationFun();
    return key;
  }

  //添加动画
  addFun(fun, keyValue) {
    let key = keyValue ?? Math.random();
    this.funList[key] = fun;
    this.animationFun();
    return key;
  }

  //移除动画
  removeFun(key) {
    delete this.funList[key];
    // console.log("移除成功", key);
  }
}

let ani = new animationSupper();

// 动画控制器
class animation {
  geometry;
  animationAct;
  //掩饰时间
  timer = 1;
  //动画携带数据
  columnData;
  //播放状态控制
  status = false;
  //每个动画专有的key
  funKey;

  //入口需要传入图形 和动画方法
  constructor(geometry, animationAct) {
    this.geometry = geometry;
    this.animationAct = animationAct;
    return this;
  }

  //修改某个动画携带的数据
  setCoumnData(columnData) {
    this.columnData = columnData;
    return this;
  }

  //修改动画时间
  setTimer(timer) {
    this.timer = timer;
    return this;
  }

  //更改动画
  setAnimationAct(animationAct) {
    this.animationAct = animationAct;
    ani.setFun(this.funKey, () => this.animationAct(this.columnData, this));
    return this;
  }

  //开始动画
  start(key) {
    this.status = true;
    setTimeout(() => {
      this.funKey = ani.addFun(
        () => this.animationAct(this.columnData, this),
        key
      );
    }, this.timer);
    return this;
  }

  //停止动画
  stop() {
    ani.removeFun(this.funKey);
    this.status = false;
  }
}
export default {
  components: { boxStyle, screeningItem },
  data() {
    return {
      alertGeoJson: null,
      alertText: null,
      buildSelect: "all",
      alertMapData: null,
      alertMap: null,
      svgDom: "",
      pointX: [],
      pointLayer: null,
      geoLayer: null,
      textLayer: null,
      alertPoint: null,
      map: null,
      geoLayerExtent: null,
      imageLayer: null,
      clickStyle: new Style({
        fill: new Fill({
          color: "rgba(247, 222, 122,0.6)",
        }),
      }),
      selectId: "",
      selectFeature: null,
      shanxiStyle: new Style({
        shadow: true,
        stroke: new Stroke({
          color: "#fff",
          width: 3,
        }),
        fill: new Fill({
          color: "rgba(255,255,255,0)",
        }),
        text: new Text({
          fill: new Fill({ color: "#333" }),
        }),
      }),
      dataScreeningData: [
        {
          title: "地区数量",
          key: "",
          value: "11",
          unit: "个",
          url: require("@/assets/images/bigData/access.png"),
        },
        {
          title: "学校数量",
          key: "",
          value: "167",
          unit: "所",
          url: require("@/assets/images/bigData/school.png"),
        },
        // {
        //   title: "资金总金额",
        //   key: "",
        //   value: "47600",
        //   unit: "万元",
        //   fromat: (i) => i,
        //   url: require("@/assets/images/bigData/manry.png"),
        // },
        {
          title: "思政工作室数量",
          key: "",
          value: "102",
          unit: "个",
          url: require("@/assets/images/bigData/home.png"),
        },
        {
          title: "特色文化育人品牌数量",
          value: "1005",
          // value: "884",
          key: "",
          unit: "个",
          url: require("@/assets/images/bigData/book.png"),
        },
        {
          title: "思政微课数量",
          // value: "10034",
          value: "10034",
          key: "",
          unit: "个",
          url: require("@/assets/images/bigData/session.png"),
        },
      ],
      CityList: [],
      selectCity: "",
      selectPoint: null,
      table: [
        {
          title: "思政工作室数量",
          value: "68",
          unit: "个",
        },
        {
          title: "特色文化育人品牌数量",
          value: "284",
          unit: "个",
        },
        {
          title: "思政微课数量",
          value: "2541",
          unit: "个",
        },
        // {
        //   title: "资金金额",
        //   value: "5200",
        //   unit: "万元",
        // },
      ],
      alertPointDomData: [],
    };
  },
  mounted() {
    document.body.appendChild(this.$refs.alertModel);
    this.init();
    this.addYear();
    this.addStudio();
    this.addBradn();
    this.addCourse();
  },
  methods: {
    animationFun({ radius }, an) {
      //如果我们添加进去的 radius 半径大于10 我们将数据还原为0
      if (radius > 15)
        an.setCoumnData({
          radius: 0,
        });
      else {
        //否则将数据++ 这里加的值越大 速度越快
        an.setCoumnData({
          radius: radius + 0.08,
        });
      }
      //捕获错误
      try {
        let color = asArray(
          an.geometry.getStyle().getImage().getStroke().getColor()
        );
        //获取到圆的style中的自定义styleImage 就是创建出来的样式源更改半径
        // ana.stop()
        color[3] = (11 - Math.floor(radius)) / 10;
        an.geometry.getStyle().getImage().getStroke().setColor(color);
        an.geometry.getStyle().getImage().setRadius(radius);
        //再更改源的style 实现动画
        an.geometry.setStyle(an.geometry.getStyle());
      } catch (e) {
        //如果出错则停止动画
        an.stop();
      }
    },
    addBackgroundClip(event) {
      const clipPolygon = event.target.getFeatures()[0].getGeometry().clone();

      this.imageLayer.on("prerender", function (event) {
        var ctx = event.context;
        var vecCtx = getVectorContext(event);
        vecCtx.setStyle(
          new Style({
            fill: new Fill({
              color: "#ffffff00",
            }),
          })
        );
        ctx.save();
        ctx.stroke();
        vecCtx.drawGeometry(clipPolygon);
        ctx.clip();
      });
      this.imageLayer.on("postrender", function (event) {
        var ctx = event.context;
        ctx.restore();
      });
      // console.log("裁切玩");
      this.map.render();
    },
    initTextAndPoint(event) {
      //在所有的要素中遍历
      event.target.getFeatures().map((item, index) => {
        let data = item.getProperties();
        this.CityList.push({ ...data, geometry: item });
        // console.log(this.CityList,"4444");
        if (data.center || data.centroid) {
          let center = data.centroid || data.center;
          this.textLayer.getSource().addFeature(
            this.addText(center, data.name, {
              fill: { color: "#baffde" },
              // stroke: { color: "#90f6d7", width: 2 },
            })
          );
          if (data.name != "太原市") return;
          center = [center[0], center[1] - 0.1];
          let geometry = this.CircleAct(center, "hollow");
          let geometryOutside = this.CircleAct(center, "hollow");
          this.pointLayer
            .getSource()
            .addFeatures([
              geometry,
              this.CircleAct(center, "solid", 5),
              geometryOutside,
            ]);
          let timer = Math.random() * 1000;
          this.donghua({
            geometry: geometry,
            animationFun: this.animationFun,
            timer: timer,
            key: data.adcode + timer,
          });
          this.donghua({
            geometry: geometryOutside,
            animationFun: this.animationFun,
            timer: timer + 400,
            key: data.adcode + timer + 400,
          });
          if (data.name != "山西省") {
            // 计算两个点之间的方向角度（bearing）
          }
        }
      });
      // 停止监听数据源更改 否则此方法一直调用
    },
    addText(xyz, text, { fill, stroke }) {
      //新建要素 点的位置为
      let feature = new Feature({
        //几何为一个点 位置在xy
        geometry: new Point(xyz),
      });
      //修改样式为文字
      console.log();
      feature.setStyle(
        new Style({
          text: new Text({
            text: text, //文字内容为传入的text
            font: "bold 18px 微软雅黑", //字体大小和字体样式
            fill: fill ? new Fill(fill) : null, //填充样式
            stroke: stroke ? new Stroke(stroke) : null,
          }),
        })
      );
      return feature;
    },
    CircleAct(xy, type, redius = 3) {
      // 创建一个圆点要素
      let a = new Feature({
        //几何对象为一个点 位置在xy
        geometry: new Point(xy),
      });
      if (type == "solid") {
        //实心
        //修改创建的要素样式为圆
        a.setStyle(
          new Style({
            image: new Circle({
              //半径为3
              radius: redius,
              //填充颜色
              fill: new Fill({
                color: "#ff000088",
              }),
            }),
          })
        );
      } else if (type == "hollow") {
        //空心
        a.setStyle(
          new Style({
            image: new Circle({
              //半径为3
              radius: redius,
              //填充颜色
              stroke: new Stroke({
                color: "#ff000088",
              }),
            }),
          })
        );
      }
      return a;
    },
    async getJsonLayer({ url, name }) {
      return new layerVector({
        name: name || undefined,
        index: 0, //进行图层层次控制
        source: this.getJsonSource(url),
        style: this.shanxiStyle,
      });
    },
    getJsonSource(url) {
      return new sourceVector({
        url: url,
        format: new GeoJSON(),
      });
    },
    async init() {
      //新建 行政区划geojson name为了下面选中的时候不影响其他图层
      this.pointLayerAct();
      this.textLayerAct();
      this.imageLayer = new Image({
        source: new ImageStatic({
          url: require("@/assets/images/bigData/mapBg.png"), // 背景图路径
          imageExtent: [
            109.40275824, 34.3809588338, 115.4139700635, 40.75244622,
          ],
        }),
        opacity: 1, // 设置背景图的透明度
      });
      this.geoLayerExtent = await this.getJsonLayer({
        url: "../geoJson/shanxiExtent.geojson",
      });
      this.geoLayerExtent.getSource().once("change", this.addBackgroundClip);
      this.geoLayer = await this.getJsonLayer({
        url: "../geoJson/shanxi.geojson",
        name: "geoLayer",
      });
      this.geoLayerExtent.setZIndex(0);
      this.geoLayer.getSource().once("change", this.initTextAndPoint);
      this.map = new Perspective({
        target: this.$refs.map,
        view: new View({
          center: [112.549248, 37.857014],
          zoom: 6.3,
          projection: "EPSG:4326",
        }),
        layers: [],
        controls: [],
        interactions: defaultInteractions({
          doubleClickZoom: false, // 禁用双击缩放
        }),
      });
       
      this.geoLayer.getSource().on("featuresloadend", (event) => {
        const extent = this.geoLayer.getSource().getExtent();
        if (extent) {
          let bili = 450 * (window.innerHeight / 900);
          this.map.getView().fit(extent, {
            // size: this.map.getSize(),
            maxZoom: 18,
            padding: [bili, bili, bili, bili],
          });
        } else {
          console.error("Empty extent provided as geometry");
        }
      });
      var r3D = new Render3D({
        style: this.shanxiStyle,
        ghost: true,
        height: -0.2,
      });
      this.geoLayerExtent.setRender3D(r3D);
      
      // this.map.setPerspective(5);//倾斜角度
      this.map.getInteractions().forEach((interaction) => {
        if (
          interaction instanceof MouseWheelZoom ||
          interaction instanceof DragPan
        ) {
          this.map.removeInteraction(interaction);
        }
      });
      this.geoLayerExtent.setZIndex(0);
      this.map.addLayer(this.geoLayerExtent);
      this.imageLayer.setZIndex(1);
      this.map.addLayer(this.imageLayer);
      this.geoLayer.setZIndex(2);
      this.map.addLayer(this.geoLayer);
      this.pointLayer.setZIndex(3);
      this.map.addLayer(this.pointLayer);
      this.textLayer.setZIndex(3);
      this.map.addLayer(this.textLayer);

      this.map.on("click", this.clickMap);
      // this.map.on("mouseenter", this.clickMap);
      this.map.on("pointermove", (event) => {
        // 检查是否在特定的图层上
        var feature = this.map.forEachFeatureAtPixel(
          event.pixel,
          function (feature) {
            return feature;
          }
        );

        // 根据是否有特定的 feature 设置不同的鼠标样式
        if (feature) {
          this.map.getTargetElement().style.cursor = "pointer"; // 设置指针样式
           this.map.forEachFeatureAtPixel(
              this.map.getEventPixel(event.originalEvent), //获取像素点
              (feature, layer) => {
                //如果图层为geoLayer并且不是上一次选中的要素
                if (layer.get("name") == "geoLayer" && feature) {
                  // console.log(feature.getProperties(),"33333");
                  let CityList=this.CityList;
                  // console.log(,"4444");
                  // this.clickCity(CityList.find(item=>item.name==feature.getProperties().name));
                  // this.mapAlert(feature.getProperties());
                }else{
                  // this.selectClear();
                }
              }
            );
        } else {
          // this.selectClear();
          this.map.getTargetElement().style.cursor = ""; // 恢复默认样式
        }
       
        // console.log(event);
       
      });
      if(this.selectCity && this.selectCity.adcode){
       }else{
        // console.log(this.CityList,"22222");
          this.clickCity(this.CityList[0]);
       }
    },
    clickMap(event) {
      // console.log(event);
      //从map中获取到像素位置下的要素
      if (!event.pixel) {
        return;
      }
      
      // this.map.forEachFeatureAtPixel(
      //   this.map.getEventPixel(event.originalEvent), //获取像素点
      //   (feature, layer) => {
      //     //如果图层为geoLayer并且不是上一次选中的要素
      //     if (layer.get("name") == "geoLayer" && feature) {
      //       console.log(feature.getProperties());
      //       this.mapAlert(feature.getProperties());
      //     }
      //   }
      // );
       this.map.forEachFeatureAtPixel(
        this.map.getEventPixel(event.originalEvent), //获取像素点
        (feature, layer) => {
          //如果图层为geoLayer并且不是上一次选中的要素
          if (layer.get("name") == "geoLayer" && feature) {
            console.log(feature.getProperties());
            // this.$router.push({path:'/home/cityTotal',query:{name:feature.getProperties().name}})
            this.mapAlert(feature.getProperties());
          }
        }
      );
    },
    mapAlert(params) {
      console.log(params,"4444");
      this.alertMapData = params;
      this.$nextTick(() => {
        this.alertMapInit(params);
      });
    },
    async alertMapInit(params) {
      if (this.alertMap) {
        this.alertGeoJson.getSource().clear();
        this.alertText.getSource().clear();
        this.alertPoint.getSource().clear();
        this.alertMap.getOverlays().clear();
        this.alertGeoJson.setSource(
          this.getJsonSource(`../geoJson/${params.adcode}.geojson`)
        );
      } else {
        this.alertGeoJson = await this.getJsonLayer({
          url: `../geoJson/${params.adcode}.geojson`,
        });
        this.alertText = new layerVector({
          name: "text",
          zIndex: 1, //进行图层层次控制
          source: new sourceVector(),
        });
        this.alertPoint = new layerVector({
          name: "point",
          zIndex: 1, //进行图层层次控制
          source: new sourceVector(),
        });
        this.alertMap = new Map({
          target: this.$refs.alertMapBox,
          view: new View({
            center: params.center,
            zoom: 8,
            projection: "EPSG:4326",
          }),
          controls: [],
          interactions: defaultInteractions({
            doubleClickZoom: false, // 禁用双击缩放
          }),
          layers: [this.alertGeoJson, this.alertText, this.alertPoint],
        });
        this.alertMap.getInteractions().forEach((interaction) => {
          if (
            interaction instanceof MouseWheelZoom ||
            interaction instanceof DragPan
          ) {
            this.alertMap.removeInteraction(interaction);
          }
        });
      }
      // this.alertMap.getView().setCenter(params.centroid);
      this.alertGeoJson.setStyle(
        new Style({
          shadow: true,
          stroke: new Stroke({
            color: "#29dfef",
            width: 3,
          }),
          fill: new Fill({
            color: "#153aaa",
          }),
          text: new Text({
            fill: new Fill({ color: "#333" }),
          }),
        })
      );
      let source = this.alertGeoJson.getSource();
      source.on("featuresloadend", () => {
        const extent = source.getExtent();
        if (extent) {
          this.alertMap.getView().fit(extent, {
            // size: this.alertMap.getSize(),
            maxZoom: 18,
            padding: [50, 50, 100, 50],
          });
        } else {
          console.error("Empty extent provided as geometry");
        }
      });
      source.on("change", (event) => {
        let extent = event.target.getExtent();
        let mapCenter = [
          (extent[0] + extent[2]) / 2,
          (extent[1] + extent[3]) / 2,
        ];
        let num = 0;
        this.alertPointDomData = [];
        event.target.getFeatures().map((item, index) => {
          let data = item.getProperties();
          let center = data.centroid || data.center;
          if (center) {
            this.alertText.getSource().addFeature(
              this.addText(center, data.name, {
                fill: { color: "#fff" },
              })
            );
            if (num > 0) return;
            this.alertPointDomData.push(data);
            this.$nextTick(() => {
              let dom = document.getElementById(data.adcode);

              if (mapCenter[0] < center[0]) {
                // console.log('左',data.adcode);
                dom.style.alignItems = "flex-start";
              } else {
                // console.log('右',data.adcode);
                dom.style.alignItems = "flex-end";
              }
              let overlay1 = new Overlay({
                element: dom, // 替换为你第一个 DOM 元素的 ID 或 DOM 引用
                offset: [0, -90], // 可选的偏移量
              });
              this.alertMap.addOverlay(overlay1);
              overlay1.setPosition(center);
            });
            num++;
            // this.alertPoint
            //   .getSource()
            //   .addFeature(
            //     this.addPoint(
            //       center,
            //       require("@/assets/images/bigData/alert_point.png"),
            //       0.4
            //     )
            //   );
            // // 设置自定义 DOM 元素的位置
          }
        });
      });
    },
    textLayerAct() {
      this.textLayer = new layerVector({
        name: "text",
        zIndex: 1, //进行图层层次控制
        source: new sourceVector(),
      });
    },
    pointLayerAct() {
      //新建空的点图层 名字为了方便控制
      this.pointLayer = new layerVector({
        name: "point",
        zIndex: 3, //进行图层层次控制
        source: new sourceVector(),
      });
    },
    donghua({ geometry, animationFun, timer, key }) {
      //使用刚才创建的动画类 创建一个动画
      let an = new animation(geometry, animationFun);
      //更改延迟执行时间
      an.setTimer(timer);
      //修改自定义数据 且开始动画
      an.setCoumnData({
        radius: 0,
      }).start(key);
    },
    addYear() {
      let value = ["太原", "大同", "阳泉", "长治","晋城",'朔州','晋中','运城','忻州','临汾','吕梁'];
      let value1 = [1833, 2100, 1800, 1800,1700,1900,1800,1500,1800,1450,1700];
      let value2 = [1732, 1700, 1500, 1500,1500,1400,1400,1300,1400,1200,1500];
      // let value3 = [1635, 1300, 700, 1200,1000,1000,1100,1300,1200,1150,1400];
      // let VALUE5 = ["2023", "2022", "2021"];
      let VALUE5 = ["思政工作室", "特色文化育人品牌",];
      var myChart = echarts.init(this.$refs.yera);
      let option = {
        grid: {
          containLabel: true,
          left: 5,
          right: 15,
          bottom: 20,
          top: 48,
        },
        legend: {
          data: VALUE5,
          textStyle: {
            color: "#ffffff", //字体颜色
          },
          origent: "right",
          top: 0,
        },
        dataZoom: [{
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: 0,
          end: 36.36, // 4/11≈36.36%
          handleSize: 8,
          height: 10,
          bottom: 0,
          backgroundColor: '#04195e',
          fillerColor: '#1890ff',
          borderColor: '#68A8CC'
        }],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: value,
          axisLabel: {
            textStyle: {
              color: "#68A8CC",
            },
            formatter: function (value) {
              let rowMAx = 4;
              let overValue = "";
              for (let i = 0; i < value.length; i++) {
                if (i % rowMAx == 0 && i != 0) {
                  overValue += "\n";
                  overValue += value[i];
                } else {
                  overValue += value[i];
                }
              }
              return overValue;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#3c71c1",
            },
          },
        },
        yAxis: {
          type: "value",
          // name: "(万元)",
          name: "(个)",
          nameTextStyle: {
            color: "#68A8CC",
          },
          axisLabel: {
            textStyle: {
              color: "#68A8CC",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#68A8CC",
            },
          },
          splitLine: {
            // y 轴分隔线配置
            show: true, // 是否显示分隔线
            lineStyle: {
              color: "#68A8CC", // 分隔线颜色
            },
          },
        },
        series: [
          {
            name: VALUE5[0],
            data: value1,
            type: "bar",
            barWidth: "15",
            barGap: "40%",
            itemStyle: {
              normal: {
                color: "#ff9c00",
              },
            },
            showBackground: false,
            backgroundStyle: {
              color: "#04195e",
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
          {
            name: VALUE5[1],
            data: value2,
            type: "bar",
            barWidth: "15",
            barGap: "40%",
            showBackground: false,
            backgroundStyle: {
              color: "#04195e",
            },
            itemStyle: {
              normal: {
                color: "#1890ff",
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
          },
          // {
          //   name: VALUE5[2],
          //   data: value3,
          //   type: "bar",
          //   barGap: "40%",
          //   barWidth: "15",
          //   showBackground: false,
          //   itemStyle: {
          //     normal: { color: "#1fd84b" },
          //   },
          //   label: {
          //     show: true,
          //     position: "top",
          //     color: "#fff",
          //   },
          // },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
    },
    addStudio() {
      Highcharts.chart("studio", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 60,
            beta: 0,
          },
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#fff",
            fontSize: "14",
          },
          labelFormatter: function (i) {
            return this.name + "年";
          },
          itemHoverStyle: {
            color: "#FFFFFF", // 悬停状态下的颜色
          },
          symbolHeight: 10, // 调整图例符号高度
          symbolWidth: 10, // 调整图例符号宽度
          symbolRadius: 0, // 调整图例符号圆角
          itemMarginTop: 10,
          align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
          verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
        },
        plotOptions: {
          pie: {
            size: 200,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2,
            borderColor: "#FFFFFF", // 设置边框颜色为白色
            dataLabels: {
              distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: true, //是否显示饼图的线形tip
              formatter: function (color) {
                return (
                  '<b style="color:' +
                  this.point.color +
                  ';font-size:14px;">' +
                  this.point.y
                  //  +
                  // "%</b></br>" +
                  // this.point.name +
                  // "年"
                );
              },
              style: {
                color: "#fff",
                textOutline: "none",
                fontSize: 14,
              },
            },
          },
        },
        series: [
          {
            size: 150,
            name: "建设数量",
            data: [
              // ["2024", 0],
              ["2023", 27],
              ["2022", 38],
              ["2021", 37],
            ],
            colors: ["#FFC808", "#FE8D37", "#517FD9"],
            // colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9"],
          },
        ],
      });
    },
    addBradn() {
      var data_val = [341, 271, 273,120],
        xAxis_val = ["2021", "2022", "2023","2024"];
      var data_val1 = [0, 0, 0, 0, 0, 0, 0];
      var option = {
        grid: {
          left: 10,
          top: "10%",
          bottom: 20,
          right: 10,
          containLabel: true,
        },

        xAxis: {
          data: xAxis_val,
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#244a7f",
            },
          },
        },

        series: [
          {
            type: "line",
            name: "linedemo",
            data: data_val,
            symbol: "circle",
            symbolSize: 8,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(236, 238, 8, 0.8)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(236, 238, 8, 0)",
                    },
                  ],
                  false
                ),
              },
              shadowColor: "rgba(0, 0, 0, 0.1)",
              shadowBlur: 10,
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "rgba(236, 238, 8,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(236, 238, 8,1)",
                  },
                ]),
                label: {
                  show: true,
                  textStyle: {
                    color: "#82acd0", // 标签文字颜色
                    textBorderColor: "transparent", // 描边颜色设为透明
                    textBorderWidth: 0, // 描边宽度设为0
                  },
                },
              },
              emphasis: {
                color: "rgb(255, 255, 255)",
                borderColor: "rgba(236, 238, 8,0.2)",
                extraCssText: "box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);",
                borderWidth: 10,
              },
            },
          },
        ],
      };
      var myChart = echarts.init(this.$refs.brand);
      myChart.clear();
      myChart.setOption(option);
    },
    addCourse() {
      var m2R2Data = [
        {
          value: 1772,
          legendname: "2021",
          name: "1",
          itemStyle: { color: "#1191ff" },
        },
        {
          value: 2908,
          legendname: "2022",
          name: "2",
          itemStyle: { color: "#18e8e8" },
        },
        {
          value: 3104,
          legendname: "2023",
          name: "3",
          itemStyle: { color: "#ffae21" },
        },
        {
          value: 1650,
          legendname: "2024",
          name: "4",
          itemStyle: { color: "#74BA4C" },
        },
      ];

      let option = {
        title: [
          {
            text: "合计",
            subtext: 9434+ "个",
            textStyle: {
              fontSize: 18,
              color: "#fff",
            },
            subtextStyle: {
              fontSize: 18,
              color: "#fff",
            },
            textAlign: "center",
            x: "34.5%",
            y: "38%",
          },
        ],

        legend: {
          type: "scroll",
          orient: "vertical",
          align: "left",
          top: "middle",
          left: "60%",
          formatter: (name) => {
            for (let i of m2R2Data) {
              if (i.name == name) {
                // ${i.itemStyle.color}
                return `${i.legendname}年   ${i.value}`;
              }
            }
          },
          textStyle: {
            color: "#ftt",
          },
          height: 250,
        },
        series: [
          {
            name: "标题",
            type: "pie",
            center: ["35%", "50%"],
            radius: ["55%", "65%"],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                length: 5,
                length2: 3,
                smooth: true,
              },
            },
            data: m2R2Data,
          },
        ],
      };
      var myChart = echarts.init(this.$refs.course);
      myChart.setOption(option);
    },
    addPoint(center, url, scale = 0.2) {
      let point = new Feature({
        geometry: new Point(center),
      });
      point.setStyle(
        new Style({
          image: new Icon({
            src: url,
            scale: scale,
          }),
        })
      );
      return point;
    },
    setAlertPostion(params) {
      let [x, y] = this.map.getPixelFromCoordinate(params.center);
      const { left, top, right, bottom, width, height } =
        this.$refs.map.getBoundingClientRect();
      let alertBottom = this.$refs.select.getBoundingClientRect().bottom;
      x = x - 15;
      y = y - 325;
      let leftx = 0;
      let topy = 0;
      if (left + width / 2 > x) {
        //在左边
        this.$refs.alert.style.left = left - 10 + "px";
        leftx = left - 10 + this.$refs.alert.clientWidth;
        this.$refs.alert.style.right = "auto";
        this.$refs.alert.style.top = this.$refs.select.clientHeight + "px";
        topy =
          this.$refs.select.clientHeight + this.$refs.select.clientHeight / 2;
      } else {
        //在右边
        this.$refs.alert.style.right = "auto";
        if (y < top) {
          this.$refs.alert.style.top = top + "px";
          topy = top;
        } else {
          topy = y - this.$refs.alert.clientHeight / 2;
          this.$refs.alert.style.top = y - this.$refs.alert.clientHeight + "px";
        }
        leftx = right - 10 - this.$refs.alert.clientWidth;
        this.$refs.alert.style.left =
          right - 10 - this.$refs.alert.clientWidth + "px";
      }
      if (left + width / 2 > x && y < alertBottom) {
        this.$refs.alert.style.top = alertBottom + "px";
      }
      // this.svgDom = `<path
      //     d="M ${x - 20} ${y - 80} L ${leftx} ${topy}"
      //     stroke="#ffcb01"
      //     stroke-width="2"
      //     fill="none"
      //   />`;
    },
    clickCity(params) {
      this.selectCity = params;
      // console.log(params);
      if(params.name=='太原市'){
      	// this.table[0].value=38;
        this.table[0].value=45;
      	this.table[1].value=385;
      	this.table[2].value=2875;
        // this.table[3].value=5200;
      }else if(params.name=='阳泉市'){
      	this.table[0].value=2;
        
      	this.table[1].value=15;
      	this.table[2].value=153;
        // this.table[3].value=4000;
      }else if(params.name=='忻州市'){
      	this.table[0].value=3;
        
      	this.table[1].value=40;
      	this.table[2].value=408;
        // this.table[3].value=4400;
      }else if(params.name=='大同市'){
      	this.table[0].value=7;
      	this.table[1].value=62;
      	this.table[2].value=704;
        // this.table[3].value=4200;
      }else if(params.name=='朔州市'){
      	this.table[0].value=3;
      	this.table[1].value=11;
      	this.table[2].value=139;
        // this.table[3].value=4300;
      }else if(params.name=='晋城市'){
      	// this.table[0].value=3;
        this.table[0].value=1;
      	this.table[1].value=48;
      	this.table[2].value=527;
        // this.table[3].value=4200;
      }else if(params.name=='临汾市'){
      	// this.table[0].value=5;
        this.table[0].value=6;
      	this.table[1].value=87;
      	this.table[2].value=900;
        // this.table[3].value=3800;
      }else if(params.name=='运城市'){
      	// this.table[0].value=10;
        this.table[0].value=8;
      	this.table[1].value=121;
      	this.table[2].value=1250;
        // this.table[3].value=4100;
      }else if(params.name=='长治市'){
      	// this.table[0].value=9;
        this.table[0].value=10;
      	this.table[1].value=76;
      	this.table[2].value=932;
        // this.table[3].value=4500;
      }else if(params.name=='晋中市'){
      	// this.table[0].value=17;
        this.table[0].value=11;
      	this.table[1].value=110;
      	this.table[2].value=1125;
        // this.table[3].value=4300;
      }else if(params.name=='吕梁市'){
      	this.table[0].value=6;
      	this.table[1].value=50;
      	this.table[2].value=421;
        // this.table[3].value=4600;
      }
      
      this.setStyle(params.geometry);
      if (!this.selectPoint) {
        this.selectPoint = this.addPoint(
          params.center,
          require("@/assets/images/bigData/address_map.png")
        );
        this.pointLayer.getSource().addFeature(this.selectPoint);
      } else {
        this.selectPoint.getGeometry().setCoordinates(params.center);
      }
      this.$nextTick(() => {
        this.setAlertPostion(params);
      });
    },
    selectClear() {
      this.selectSetStyle();
      this.selectCity = null;
      // console.log(this.pointLayer);
      this.selectCity = null;
      this.pointLayer.getSource().removeFeature(this.selectPoint);
      this.selectPoint = null;
    },
    selectSetStyle() {
      if(this.selectFeature){
         this.selectFeature.setStyle(this.shanxiStyle);
      }
      this.selectFeature = null;
    },
    setStyle(feature) {
      //如果选中的要素有则还原style 且将其他设置为空
      if (this.selectFeature) {
        this.selectSetStyle();
      }
      // 将唯一id提出来 进行性能优化 避免下一次再更改样式
      this.selectId = feature.ol_uid;
      //将给要素给到选中要素 为了下一次恢复使用
      this.selectFeature = feature;
      //修改要素样式
      feature.setStyle(this.clickStyle);
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  overflow-y: auto;
  z-index: 2;
  &_map_select_box {
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    background: url("~@/assets/images/bigData/border.png") no-repeat;
    background-size: 100% 100%;
    width: 14vw;
    max-width: 250px;
    min-height: 200px;
    position: absolute;
    top: 0;
    left: 0;
    padding: 2vh 1vw;
    > div {
      display: flex;
      width: 6vw;
      max-width: 100px;
      height: 4vh;
      margin-bottom: 1vh;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 1vw;
      justify-content: center;
      align-items: center;
      color: #d8feff;
      text-align: center;
      background: url("~@/assets/images/bigData/box_bg_border.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:nth-child(odd) {
        margin-right: auto;
      }
    }
  }
  &_list {
    width: 24vw;
    min-width: 346px;
    max-width: 446px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    // height: fit-content;
    height: 100%;
    > div {
      flex: 1;
      min-height: 25vh;
    }
  }
  #map {
    flex: 1;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
  }
  .data_screening {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: 47%;
      margin-bottom: 10px;
      // &:nth-child(odd) {
      //   margin-right: 20px;
      // }
    }
  }
  .alert_box {
    display: flex;
    align-items: center;
    width: 300px;
    height: 200px;
    position: absolute;
    background: url("~@/assets/images/bigData/alert_box_bg.png") no-repeat;
    background-size: 100% 100%;
    flex-direction: column;
    color: #ffffff;
    font-family: Microsoft YaHei;
    z-index: 4;
    &_title {
      cursor: pointer;

      font-weight: bold;
      width: 80%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      background: url("~@/assets/images/bigData/alert_box_title.png") no-repeat;
      background-size: 100% 100%;
    }
    &_content {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 10px;
      > div {
        display: flex;
        align-items: center;
        text-align: center;
        flex: 1;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 15px;
        color: #ffffff;
        font-style: normal;
        text-transform: none;
        &:nth-child(odd) {
          background: url("~@/assets/images/bigData/table_bg.png");
        }
        &:last-child {
          background: linear-gradient(
            to right,
            rgba(39, 150, 242, 0) -2%,
            rgba(39, 150, 242, 1) 50%,
            rgba(39, 150, 242, 0) 108%
          );
          background-size: 100% 2px; /* 控制渐变的高度 */
          background-position: bottom;
          background-repeat: no-repeat;
        }
        > div {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:first-child {
            flex: 0.6;
            border-right: 1px solid #2796f2;
          }
          &:last-child {
            flex: 0.4;
            width: 13px;
            font-size: 15px;
            color: #fff38d;
          }
        }
      }
    }
  }
}
.tables {
  width: 100%;
  thead {
    tr {
      background-color: #082569;
      height: 47px;
      th {
        height: 30px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        font-size: 1vw;
        color: #8298fb;
      }
    }
  }
  tbody {
    tr {
      height: 36px;
      border-bottom: 1px solid #213e78;
      td {
        // height: 36px;
        font-weight: 300;
        line-height: 36px;
        font-size: 0.9vw;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}
.alert_map {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  min-width: 600px;
  min-height: 300px;
  z-index: 100;
  position: fixed;
  background: #00000066;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 60vw;
    display: flex;
    flex-direction: column;
    height: 60vh;
    min-width: 600px;
    min-height: 300px;
    background: url("~@/assets/images/bigData/alert-bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  &_title {
    width: 100%;
    font-family: MicrosoftYaHei;
    font-size: 1.6vw;
    color: #e2ebff;
    line-height: 75px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    letter-spacing: 2px;
  }
  &_box {
    flex: 1;
  }
  &_point {
    position: absolute;
    display: flex;
    width: calc(140px + 44px);
    flex-direction: column;
    &_content {
      width: 140px;

      background: url("~@/assets/images/bigData/alert_point_box.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      height: 40px;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      &_icon {
        width: 30px;
        height: 30px;
        background-color: red;
        background: url("~@/assets/images/bigData/alert_icon.png") no-repeat;
        background-size: 100% 100%;
        margin-left: 5px;
      }
      &_text {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #8f5400;
        text-align: center;
        font-style: normal;
        width: calc(100% - 5px - 30px);
        text-transform: none;
      }
    }
    img {
      width: 27%;
    }
  }
}
::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度 */
}

::-webkit-scrollbar-track {
  background: #01389c; /* 滚动条轨道背景色 */
  border-radius: 10px; /* 可选：轨道圆角 */
}

::-webkit-scrollbar-thumb {
  background: #a0d1f4; /* 滚动条颜色 */
  border-radius: 10px; /* 可选：滚动条圆角 */
}

::-webkit-scrollbar-thumb:hover {
  background: #01389c; /* 鼠标悬停时滚动条颜色 */
}
* {
  transform: translate3d(0, 0, 0);
  line-height: normal;
}
</style>